import React from "react";

export default function MSAccess_Sgn() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Sgn</h1>
      <p>This is the MSAccess_Sgn component generated from the SQL JSON.</p>
    </div>
  );
}
